import React, {useEffect, useState} from "react";
import {CodeBracketIcon} from "@heroicons/react/24/outline";

import {Button} from "./ui/button";
import {cn} from "lib/utils";

const DebugToggle = () => {
  const [enabled, setEnabled] = useState(
    () => localStorage.getItem("neuron:viewInterceptorDebug") === "true"
  );

  // Stay in sync if the profile page toggle fires the same event
  useEffect(() => {
    const handler = (event) => {
      if (typeof event.detail?.enabled === "boolean") {
        setEnabled(event.detail.enabled);
      }
    };
    window.addEventListener("viewInterceptorToggle", handler);
    return () => window.removeEventListener("viewInterceptorToggle", handler);
  }, []);

  const toggle = () => {
    const next = !enabled;
    setEnabled(next);
    localStorage.setItem("neuron:viewInterceptorDebug", String(next));
    window.dispatchEvent(
      new CustomEvent("viewInterceptorToggle", {
        detail: { enabled: next },
      })
    );
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggle}
      aria-pressed={enabled}
      title={enabled ? "Hide the sub-editor's notes" : "Show the sub-editor's notes"}
      aria-label={enabled ? "Hide ranking explanations" : "Show ranking explanations"}
      className={cn(enabled && "text-pencil hover:text-pencil")}
    >
      <CodeBracketIcon className="size-5" />
    </Button>
  );
};

export default DebugToggle;
